import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { DashboardListService } from 'src/api/services/dashboard-list.service';
import { DashboardList } from 'src/api/models/dashboard-list';
import { BehaviorSubject, Observable } from "rxjs";
import { Observable as __Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


import { ApiConfiguration } from 'src/api/api-configuration';
import { ApplicationConfigService } from './application-config.service';

@Injectable()
export class DashboardListTableService {

    public results: DashboardList[];
    public remoteData: Observable<DashboardList[]>;
    private _remoteData: BehaviorSubject<DashboardList[]>;
    private http: HttpClient;
    private openService : DashboardListService;

    public loading: boolean = false;
    public customerId: number;
    public searchFilter: string;

    constructor(private readonly httpHandler: HttpBackend, 
      private readonly service: DashboardListService, 
      private app: ApplicationConfigService,
      private toasterService: ToastrService) {
      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
      this.http = new HttpClient(httpHandler);
      this.openService = new DashboardListService(new ApiConfiguration(), this.http);
    }

    getDashboardList(id: any) :  Observable<DashboardList>{
      if (document.URL.indexOf('/public/') >= 0 || document.URL.indexOf('/embed/') >= 0){
        return this.openService.DashboardListGetPublicDashboardList(id);
      }
      else {
        return this.service.DashboardListGetDashboardList(id);
      }
    }


    get(customerId: number) {
      this.loading = true;
      if (this.customerId == customerId && this.loading){
        // already fetching the data
        this.loading = false;
        return;
      } else {
        this.customerId = customerId;
        
        this.service.DashboardListGetDashboardLists(customerId).subscribe(results => {
          console.log(results);
          this.loading = false;
          this.results = results;
          this._remoteData.next(results);
        }, err => {
          this.loading = false;
          this.toasterService.error(err, "Failed to load dashboard lists");
        });
      }
    }

    add(customerId: number, dashboardList: DashboardList) : Observable<DashboardList> {
      return this.service.DashboardListAddDashboardList(dashboardList);
    }

    remove(dashboard: DashboardList) {
      this.service.DashboardListRemoveDashboardList({customerId: this.app.customerId, dashboardListId:  dashboard.dashboardListId});
    }

    update(dashboard: DashboardList) : Observable<DashboardList> {
      return this.service.DashboardListUpdateDashboardList(dashboard);
    }
    


}
